export const mutations = {
  setCompanie: (state, companie) => {
    state.companie = companie; 
  }
};
